<template>
  <div>
    <div class="system-btn-common" :class="hasPerms(item.authorityFlag) ? '' : 'no-permission'" @click="handleTo(item)">
      <i class="icon iconfont" :class="item.icon"></i>
      <div class="title">{{ item.title }}</div>
      <div class="desc">{{ item.desc }}</div>
    </div>
  </div>
</template>
<script>
import { hasPermission } from '@/permission/index.js'

export default {
  props: {
    item: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleTo (item) {
      console.log(item)
      if (!this.hasPerms(item.authorityFlag)) {
        return this.$message.warning('暂无操作权限')
      }
      if (item.path) {
        this.$router.push({ path: item.path })
      }
    },
    hasPerms: function (flag) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(flag) // & !this.disabled
    }
  }
}
</script>
